/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { ACTIONS, GuardRequest } from './types';

export class DefaultGuardRequest implements GuardRequest {
    constructor(
        private subject: { [key: string]: unknown; },
        private resourceName: string,
        private action: ACTIONS
    ) {}

    toJS() {
        return {
            subject: {
                role: this.subject.role,
                group: this.subject.group,
                username: this.subject.username,
            },
            resource: { name: this.resourceName },
            action: this.action,
        };
    }
}
